import LoaderIcon from "@/assets/images/loader.svg?react";
import clsxm from "@/lib/clsxm";
import {type FC} from "react";

const Loader: FC<{
  styles?: {containerClassName?: string; loaderClassName?: string};
}> = ({styles}) => {
  return (
    <div
      className={clsxm("flex justify-center", styles?.containerClassName)}
      aria-label="Loading..."
      role="status"
      key="loader">
      <LoaderIcon className={clsxm("size-6 animate-spin", styles?.loaderClassName)} />
    </div>
  );
};

export default Loader;
